module.exports = __webpack_public_path__ + "615f368906a6738e8550f7304b04c5b7.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_6.png
// module id = 80
// module chunks = 0